<template>
  <div class="ob__alerts" v-if="onboardingDetails">
    <div
      class="ob__alert ob__alert--error"
      v-if="
        onboardingDetails.msa_status == 'NONE' ||
        onboardingDetails.w9_status == 'NONE' ||
        onboardingDetails.ach_status == 'NONE' ||
        onboardingDetails.gig_contract_needed
      "
    >
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <img
            v-on="on"
            src="@/assets/onboarding-alerts/needs-signature.svg"
            class="ob__icon"
            alt="Signature needed alert."
          />
        </template>
        <div>
          <div v-if="onboardingDetails.msa_status == 'NONE'">
            Creator has not signed a current-year MSA.
          </div>
          <div v-if="onboardingDetails.w9_status == 'NONE'">
            Creator has not filled out a W-9.
          </div>
          <div v-if="onboardingDetails.ach_status == 'NONE'">
            Creator has not filled out an ACH authorization.
          </div>
          <div v-if="onboardingDetails.gig_contract_needed">
            Creator has gig(s) that need a contract.
          </div>
        </div>
      </v-tooltip>
    </div>
    <div
      class="ob__alert ob__alert--error"
      v-if="!onboardingDetails.qb_is_linked"
      @click.stop.prevent="onboardLinkVendor"
    >
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <img
            v-on="on"
            src="@/assets/onboarding-alerts/no-qbo-vendor.svg"
            class="ob__icon"
            alt="Broken link alert"
          />
        </template>
        <div>Creator is not linked to a QBO vendor.</div>
      </v-tooltip>
    </div>
    <div
      class="ob__alert ob__alert--msg"
      v-if="
        onboardingDetails.msa_status == 'OUT_FOR_SIGNATURE' ||
        onboardingDetails.w9_status == 'OUT_FOR_SIGNATURE' ||
        onboardingDetails.ach_status == 'OUT_FOR_SIGNATURE' ||
        onboardingDetails.ga_withholding_status == 'OUT_FOR_SIGNATURE' ||
        onboardingDetails.gig_contract_signature_needed ||
        onboardingDetails.gig_extension_signature_needed
      "
    >
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <img
            v-on="on"
            src="@/assets/onboarding-alerts/out-for-signature.svg"
            class="ob__icon"
            alt="Out for signature alert"
          />
        </template>
        <div>
          <div v-if="onboardingDetails.msa_status == 'OUT_FOR_SIGNATURE'">
            MSA out for signature.
          </div>
          <div v-if="onboardingDetails.w9_status == 'OUT_FOR_SIGNATURE'">
            W-9 out for signature.
          </div>
          <div v-if="onboardingDetails.ach_status == 'OUT_FOR_SIGNATURE'">
            ACH authorization out for signature.
          </div>
          <div v-if="onboardingDetails.ga_withholding_status == 'OUT_FOR_SIGNATURE'">
            GA Film Tax Credit Withholding Acknowledgement out for signature.
          </div>
          <div v-if="onboardingDetails.gig_contract_signature_needed">
            Creator has a gig contract that needs a signature.
          </div>
          <div v-if="onboardingDetails.gig_extension_signature_needed">
            Creator has a gig extension that needs a signature.
          </div>
        </div>
      </v-tooltip>
    </div>
    <AreYouSureDialog
      :dialog="onboardLinkVendorDialog"
      @yes="onboard('qbo_link', onboardLinkVendorId)"
      @no="onboardLinkVendorDialog = false"
      :yes-disabled="!onboardLinkVendorURLValid"
    >
      <p>
        Paste the URL for the QBO Vendor and press link to associate them with
        that vendor in Community. For example:
        <code>https://app.qbo.intuit.com/app/vendordetail?nameId=1234</code>
      </p>
      <TextField v-model="onboardLinkVendorURL" class="mb-4" />
      <p v-if="onboardLinkVendorId">
        Extracted vendor ID: {{ onboardLinkVendorId }}
      </p>
      <template #yes> Link </template>
      <template #no> Cancel </template>
    </AreYouSureDialog>
  </div>
</template>

<script>
import onboardMixin from "@/mixins/onboard.mixin";

export default {
  mixins: [onboardMixin],
  props: {
    onboardingDetails: Object,
    value: Object,
  },
  methods: {
    onboardLinkVendor() {
      if (!this.currentUser || !this.currentUser.is_finance) return;
      this.onboardLinkVendorDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.ob {
  &__alerts {
    display: flex;
  }
  &__alert {
    min-width: 18px;
    height: 18px;
    display: flex;
    &:not(:last-child) {
      margin-right: 2px;
    }
  }
  &__icon {
    width: 18px;
    height: 18px;
  }
}
</style>
